import { createContext, useContext, useEffect, useState } from "react";

export const ACCENT_COLORS = [
  { name: "Blue", hex: "#1C8CFF" },
  { name: "Emerald", hex: "#10D876" },
  { name: "Violet", hex: "#8B5CF6" },
  { name: "Crimson", hex: "#FF3B47" },
  { name: "Amber", hex: "#F5A623" },
  { name: "Cyan", hex: "#00D5FF" },
  { name: "Rose", hex: "#FF4D8D" },
  { name: "Teal", hex: "#14B8A6" },
  { name: "Indigo", hex: "#6366F1" },
  { name: "Orange", hex: "#FF7A1A" },
];

function hexToRgba(hex, a) {
  const m = hex.replace("#", "");
  const r = parseInt(m.slice(0, 2), 16), g = parseInt(m.slice(2, 4), 16), b = parseInt(m.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [accent, setAccentState] = useState(() => localStorage.getItem("sfx_accent") || "#1C8CFF");

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--sfx-accent", accent);
    root.style.setProperty("--sfx-accent-glow", hexToRgba(accent, 0.6));
    root.style.setProperty("--sfx-accent-soft", hexToRgba(accent, 0.15));
  }, [accent]);

  const setAccent = (hex) => { localStorage.setItem("sfx_accent", hex); setAccentState(hex); };

  return <ThemeContext.Provider value={{ accent, setAccent }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
